import 'angular:locale/data:en';
import 'angular:locale/data:bg';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
